import useHome from './useHome'
import SpeedFormation from './SpeedFormation/SpeedFormation'
import { Gamification } from './Gamification'
import HomeMessages from './HomeMessages/HomeMessages'
import { HalfCard, Card, FlexContainer, Header1 } from '@/shared/theme/styled-components'

const Home = () => {
  const { data, isLoading, hasHomeMessages, hasSpeedFormation, country, t } = useHome()

  if (isLoading || !data) {
    return (
      <Card>
        <p>{t('common:fetching_data')}</p>
      </Card>
    )
  }

  return (
    <>
      <HomeMessages hidden={!hasHomeMessages} />
      <FlexContainer id='home-welcome'>
        <HalfCard hidden={!hasSpeedFormation}>
          <Header1>{t('home:speed_formation.title')}</Header1>
          <SpeedFormation />
        </HalfCard>
      </FlexContainer>
      <Gamification country={country} />
    </>
  )
}

export default Home
